<div *ngIf="isMobile">
  <app-list-mobile></app-list-mobile>
</div>
<div *ngIf="!isMobile">
  <app-list-desktop></app-list-desktop>
</div>
